export class Contract {
  contractNo: number;
  product: string;
  allowedReturns: number;
  usedReturns: number;
  contractId: string;
  maintStartDate: string;
  maintEndDate: string;
}

export interface ContractId {
  contractId: string;
}

export class AddContract {
  contractNo: number;
  contractPassword: string;
  comment?: string;
}
